import { NgModule } from '@angular/core';
import {
  checkoutB2BTranslationChunksConfig,
  checkoutB2BTranslationsDe,
  checkoutB2BTranslationsEn,
  checkoutB2BTranslationsZh,
} from '@spartacus/checkout/b2b/assets';
import { CheckoutB2BRootModule } from '@spartacus/checkout/b2b/root';
import {
  checkoutTranslationChunksConfig,
  checkoutTranslationsDe,
  checkoutTranslationsEn,
  checkoutTranslationsZh,
} from '@spartacus/checkout/base/assets';
import { CHECKOUT_FEATURE, CheckoutRootModule } from '@spartacus/checkout/base/root';
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core';

@NgModule({
  declarations: [],
  imports: [CheckoutRootModule, CheckoutB2BRootModule],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [CHECKOUT_FEATURE]: {
          module: () => import('./checkout-wrapper.module').then((m) => m.CheckoutWrapperModule),
        },
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: { en: checkoutTranslationsEn, de: checkoutTranslationsDe, zh: checkoutTranslationsZh },
        chunks: checkoutTranslationChunksConfig,
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: { en: checkoutB2BTranslationsEn, de: checkoutB2BTranslationsDe, zh: checkoutB2BTranslationsZh },
        chunks: checkoutB2BTranslationChunksConfig,
      },
    }),
  ],
})
export class CheckoutFeatureModule {}
